<script setup lang="ts">
import './assets/style.scss'
import { useConfirm, VIcons } from '@/shared/ui'
import { useGroupControl, useGroupUpdate } from './../model/api.ts'
import { computed, type PropType } from 'vue'
import { isEqual } from 'lodash'
import { useTranslate } from '@/shared/lib'
import { useAuth } from '@/entities/Auth'

const props = defineProps({
  object_ids: {
    type: Array as PropType<number[]>,
    required: true,
  },
  is_group: {
    type: Boolean,
    default: false,
  },
  filter: {
    type: Object as PropType<any>,
    default: {},
  },
  total: {
    type: Number,
    default: 0,
  },
})

const { send: sendControl } = useGroupControl()
const { send: sendState } = useGroupUpdate()
const { trs } = useTranslate()
const { show } = useConfirm()
const { isPermissions } = useAuth()

const isNotFiltered = computed(() => {
  return isEqual(props.filter, { errors: [], statuses: [] })
})

/**
 * Обработка отправки команды
 * @param type
 * @param value
 */
const clickHandler = (type: string, value: number) => {
  let message = ''
  let command = ''

  if (type === 'mode') {
    command = trs('itf.commands_gen.control_auto')
  } else {
    command = trs(`itf.commands_gen.${value ? 'on' : 'off'}`)
  }

  if (props.is_group) {
    message = trs('itf.set_command_group', {
      command,
      for: isNotFiltered.value
        ? trs('itf.all_objects_group')
        : trs('itf.filtered_objects_group', { num: props.total }),
    })
  } else {
    message = trs('itf.set_command', { command })
  }

  show({
    confirmFunc: () =>
      sendControl({
        objectIds: props.object_ids,
        isGroup: props.is_group,
        command: {
          filter: props.filter,
          contactor: -1,
          type,
          value,
        },
      }),
    content: message,
  })
}

/**
 * Отправка команды на опрос модулей
 */
const clickState = () => {
  let message = ''

  if (props.is_group) {
    message = trs('itf.set_command_group', {
      command: trs('itf.commands_gen.refresh'),
      for: isNotFiltered.value
        ? trs('itf.all_objects_group')
        : trs('itf.filtered_objects_group', { num: props.total }),
    })
  } else {
    message = trs('itf.set_command', {
      command: trs('itf.commands_gen.refresh'),
    })
  }

  show({
    confirmFunc: () =>
      sendState({
        objectIds: props.object_ids,
        isGroup: props.is_group,
        command: {
          filter: props.filter,
        },
      }),
    content: message,
  })
}
</script>

<template>
  <span class="control_compact" :class="{ disabled: !isPermissions(['DEVICE_CONTROL']) }">
    <VBtn color="warning" density="comfortable" @click="clickHandler('mode', 1)">
      {{ $t('itf.auto') }}
    </VBtn>
    <VBtn color="warning" density="comfortable" @click="clickHandler('switch', 1)">
      {{ $t('itf.on_short') }}
    </VBtn>
    <VBtn color="warning" density="comfortable" @click="clickHandler('switch', 0)">
      {{ $t('itf.off_short') }}
    </VBtn>
    <VBtn color="warning" density="comfortable" @click="clickState">
      <VIcons type="refresh" />
    </VBtn>
  </span>
</template>
